function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M62.413 55.226c-.52-.283-5.202-4.884-9.545-4.884-2.258 0-4.028.682-5.59 1.282-1.582.61-3.077 1.186-5.241 1.186-2.522 0-4.616-.77-6.464-1.448-1.49-.547-2.777-1.02-4.094-1.02-1.316 0-2.602.473-4.092 1.02-1.847.679-3.942 1.448-6.464 1.448-2.164 0-3.66-.576-5.242-1.186-1.561-.6-3.332-1.282-5.59-1.282-4.342 0-9.025 4.601-9.544 4.884 0 0 1.993-1.182 3.65-1.182 1.656 0 3.282 1.234 5.895 1.234 1.34 0 2.433.42 3.816.953 1.753.675 3.934 1.514 7.015 1.514 3.4 0 6.155-1.01 8.166-1.75.916-.336 1.953-.717 2.39-.717.44 0 1.477.38 2.392.718 2.011.738 4.765 1.75 8.166 1.75 3.081 0 5.262-.84 7.015-1.515 1.383-.533 2.476-.953 3.816-.953 2.613 0 3.69-1.234 5.896-1.234 2.222 0 3.67 1.182 3.67 1.182z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.267 5.202a5.167 5.167 0 00-.544-.145 2.326 2.326 0 10-1.892-.124c-6.678.434-16.816 9.23-17.139 24.125-.128 5.918.622 10.762 2.689 14.28l22.344-.159c3.267-4.121 6.27-9.338 6.27-16.177 0-9.1-6.642-20.136-11.728-21.806z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.96 21.93c-2.457-8.017-8.942-15.864-14.66-16.9a2.326 2.326 0 10-1.925-.078 5.638 5.638 0 00-1.161.25c-5.073 1.67-11.57 12.888-11.57 21.8 0 6.574 2.663 12.238 5.737 16.337l22.344-.16c2.114-3.528 4.703-9.921 1.232-21.251z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.653 52.504c-2.808-1.288-6.785-2.205-10.777-2.205-3.994 0-7.732.813-11.086 2.288 3.353 1.474 7.03 2.33 11.023 2.33 3.995 0 7.491-.94 10.846-2.413z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.84374562,
  strokeLinejoin: "bevel"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.488 44.738l-.003-.003c-2.72-1.17-5.85-2.15-9.899-2.15-4.052 0-7.177.982-9.898 2.153 0 0-.61 3.96-.67 4.855a199.54 199.54 0 01-.229 2.993c3.354-1.475 7.092-2.288 11.086-2.288 3.916 0 7.472.783 10.777 2.205a62.742 62.742 0 00-.53-3.84 692.04 692.04 0 01-.64-3.936z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999,
  strokeLinejoin: "bevel"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.786 52.588c3.353-1.475 7.092-2.288 11.086-2.288 3.915 0 7.47.783 10.777 2.205-.085-.918-.288-1.49-.416-2.662-3.322-1.164-6.69-1.757-10.413-1.757-3.765 0-7.496.683-10.85 1.872-.016 1.032-.191 2.63-.191 2.63z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999,
  strokeLinejoin: "bevel"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.685 44.738c2.72-1.17 5.848-2.173 9.902-2.199 3.451-.023 7.179 1.027 9.9 2.197.149-.15.78-.341 1.239-1.558-2.288-2.477-5.69-3.77-11.139-3.77-5.814 0-8.918 1.45-11.206 3.93.45 1.215 1.15 1.248 1.299 1.398z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.0985361599999999
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.84374562,
  d: "M30.59 39.41v3.13"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.64081276,
  d: "M27.602 25.967v6.035l-1.099 1.1 2.198 2.197 2.197-2.198-1.09-1.09v-6.044h5.469l1.098 1.1 2.198-2.198-2.198-2.198-1.09 1.09h-5.477v-4.939l1.09-1.09-2.197-2.196-2.198 2.196 1.099 1.102v4.928H22.1l-1.09-1.09-2.198 2.197 2.197 2.197 1.1-1.099z"
});

function SvgWhiteBishop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.984 58.295"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgWhiteBishop;